export const CLOSING_THREAD = 'CLOSING_THREAD';
export const OPENING_THREAD = 'OPENING_THREAD';